<template>
  <div class="invoice-summary">
    <table class="table-invoice-summary">
      <tr class="table-invoice-summary__row">
        <td>{{ $t('form.invoiceForm.summary.priceNoVat') }}</td>
        <td data-test="sum_no_vat">
          {{ (sum.noVat) }}
        </td>
      </tr>
      <tr
        v-for="(vat, key) in vatValues"
        :key="vat.value"
        v-show="key !== 'totalVatIncl' && key !== 'totalNoVat' && key != 0"
      >
        <td>{{ $t('form.invoiceForm.summary.vat') }} {{ key }} %</td>
        <td :data-test="`${key}%_vat_value_price`">
          {{ _priceFormat(vatValues[key]) }}
        </td>
      </tr>
      <tr>
        <td>{{ $t('form.invoiceForm.summary.priceVatAdded') }}</td>
        <td data-test="sum_vat_incl">
          {{ sum.vatIncl }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import {
  sumPrice, getVatSumList, priceFormat,
} from '~/lib/calculations';
import { INVOICE_KIND_VAT_DUTY_REVERSED } from '~/config/constants';

export default {
  computed: {
    ...mapState('invoiceForm', [
      'vat_calculation',
      'kind',
    ]),
    ...mapGetters('invoiceForm', ['linesWithoutDeleted']),

    vatValues() {
      if (this.kind === INVOICE_KIND_VAT_DUTY_REVERSED) {
        return [];
      }

      return getVatSumList(this.linesWithoutDeleted, this.vat_calculation);
    },
    sum() {
      const values = sumPrice(
        this.linesWithoutDeleted,
        this.vat_calculation,
      );

      if (this.kind === INVOICE_KIND_VAT_DUTY_REVERSED) {
        values.noVat = values.vatIncl;
      }

      return {
        noVat: priceFormat(values.noVat, this.$store.state, false),
        vatIncl: priceFormat(values.vatIncl, this.$store.state, true),
      };
    },

  },
  methods: {
    _priceFormat(value) { return priceFormat(value, this.$store.state); },
  },
};
</script>

<style lang="scss">
  .invoice-summary {
    background-color: $--color-background;
    border-radius: 8px;
    display: flex;
    justify-content: flex-end;
    margin-top: rem(30px);
    margin-bottom: rem(30px);
    padding: rem(30px);

    @include res(xs-only, $--breakpoints-spec) {
      margin-top: rem(15px);
      justify-content: flex-start;
    }
  }

  .table-invoice-summary {
    tr:first-child {
      font-size: rem(17px);

      @include res(sm-and-down, $--breakpoints-spec) {
        font-size: rem(14px);
      }
    }

    tr:last-child {
      font-size: rem(23px);
      font-weight: 700;

      @include res(sm-and-down, $--breakpoints-spec) {
        font-size: rem(16px);
      }
    }

    td {
      text-align: right;
    }

    td:first-child {
      padding-right: rem(150px);

      @include res(sm-and-down, $--breakpoints-spec) {
        padding-right: rem(30px);
      }
    }

    td:last-child {
      min-width: rem(153px);

      @include res(sm-and-down, $--breakpoints-spec) {
        min-width: 0;
      }
    }
  }
</style>
